// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"341":"39887c0d","705":"de01db67","874":"2290e8e4"}[chunkId] + ".js";
};